export default __webpack_public_path__ + "static/media/icn-agent-active.a90cb80a.svg";